import { useMemo } from 'react';
import { useGetCommonStore } from '@/store';
import { doublePadding, ScreenSize } from '@/styles/helpers';
import { useWindowSize } from './windowSize';

export const useDevice = () => {
  const useCommonStore = useGetCommonStore();

  const isMobileServer = useCommonStore.use.isMobileDevice();
  const { width } = useWindowSize();

  const isMobileDevice = useMemo(() => {
    if (!width) return isMobileServer;

    return ScreenSize.DESKTOP + doublePadding >= width;
  }, [width, isMobileServer]);

  return { isMobileDevice };
};
